import React, { useState } from "react"
import MetaTags from 'react-meta-tags';
import {
  Container,
  Row, Col,
  Card, CardBody,
  Button,
  Input, Label,
  Modal, ModalHeader, ModalBody, ModalFooter,
  FormGroup, FormText, Form
} from "reactstrap"
import Select from "react-select"
import { post, postMultipart } from "../../helpers/api_helper"
import * as url from "../../helpers/url_helper"
import moment from "moment";
const FormData = require('form-data');

import cogoToast from "cogo-toast";
import { connect } from "react-redux"

import Lightbox from "react-image-lightbox"
import "react-image-lightbox/style.css"

const DailyLogbook = props => {

  const [loading, setLoading] = React.useState(false);

  const [data, setData] = React.useState([]);
  const [fields, setFields] = React.useState([]);

  const [servicetypes, setServicetypes] = React.useState([]);
  const [groups, setGroups] = React.useState([]);

  const [selectedServicetypes, setSelectedServicetypes] = React.useState([]);
  const [displayedGroups, setDisplayedGroups] = React.useState([]);
  const [selectedGroups, setSelectedGroups] = React.useState([]);

  const [reportDate, setReportDate] = React.useState(moment().format('YYYY-MM-DD'));

  // Checkboxes
  const [completed, setCompleted] = React.useState(true);
  const [canceled, setCanceled] = React.useState(false);
  const [delayed, setDelayed] = React.useState(false);
  const [missed, setMissed] = React.useState(false);
  const [verified, setVerified] = React.useState(false);
  const [nonVerified, setNonVerified] = React.useState(true);

  // Filters
  const [uom, setUom] = React.useState(false);
  const [fieldRange, setFieldRange] = React.useState(false);
  const [safeRange, setSafeRange] = React.useState(false);
  const [alertValues, setAlertValues] = React.useState(false);

  // Show / hide columns
  const [scantype, setScantype] = React.useState(false);
  const [userComments, setUserComments] = React.useState(false);
  const [mapLocation, setMapLocation] = React.useState(false);
  const [attachments, setAttachments] = React.useState(false);
  const [verifications, setVerifications] = React.useState(false);

  // Image display
  const [showLightbox, setShowLightbox] = React.useState(false);
  const [images, setImages] = React.useState([]);
  const [photoIndex, setPhotoIndex] = React.useState(0);


  // Verification
  const [verifyThese, setVerifyThese] = React.useState([]);
  const [verifyComment, setVerifyComment] = React.useState('');
  const [verifyImages, setVerifyImages] = React.useState([]);
  const [verification, setVerification] = React.useState(null);


  // console.log('verifyImages', verifyImages);

  const init = () => {

    let initData = {
      property_id: props.filterProperty.id,
      block_id: props.filterBlock.id,
    };

    setLoading(true);
    post(url.INIT_DAILYLOGBOOK, initData)
      .then((response) => {
        console.log('RESP', response);
        if (response.status == 200) {
          setServicetypes(response.data.servicetypes);
          setGroups(response.data.groups);
        }
        else if (response.status == 400) {
          cogoToast.error('Could not fetch data');
        }
        else {
          console.log('err::', response);
          cogoToast.error('Could not fetch data');
        }
        setLoading(false);
      }, (error) => {
        console.log(error);
        setLoading(false);
      });

  };


  const fetchData = () => {

    if (selectedGroups.length < 1) {
      cogoToast.error('Please select some groups');
      return;
    }

    if (!completed && !canceled && !delayed && !missed) {
      cogoToast.error('Please select at least one task status');
      return;
    }

    if (!verified && !nonVerified) {
      cogoToast.error('Please select at least one verification status');
      return;
    }

    let formData = {
      report_date: reportDate,
      groups: selectedGroups.map(g => g.value),
      property_id: props.filterProperty.id,
      block_id: props.filterBlock.id,
      completed: completed,
      canceled: canceled,
      delayed: delayed,
      missed: missed,
      verified: verified,
      nonverified: nonVerified,
    };

    setLoading(true);
    post(url.GET_DAILYLOGBOOK, formData)
      .then((response) => {
        console.log('RESP', response);
        if (response.status == 200) {
          // let checklists = [];
          // response.data.data.map((cCol, cColIdx) => {
          //   cCol.data = JSON.parse(cCol.data);
          //   checklists.push(cCol);
          // });
          setData(response.data);
          // setFields(response.data.fields);
        }
        else if (response.status == 400) {
          cogoToast.error('Could not fetch report');
        }
        else {
          console.log('err::', response);
          cogoToast.error('Could not fetch report');
        }
        setLoading(false);
      }, (error) => {
        console.log(error);
        setLoading(false);
      });

  };



  const doVerify = async () => {

    console.log('verifying');

    console.log(verifyImages);

    // return;

    if (verifyComment.trim() == '') {
      cogoToast.error('Please add a verification comment');
      return;
    }

    let form = await new FormData(document.querySelector('#verForm'));
    await form.set('checklist_ids', verifyThese.map(v => v.id).join(','));
    await form.set('comment', verifyComment);

    for (let i = 0; i < verifyImages.length; i++) {
      form.append(`images[${i}]`, verifyImages[i])
    }


    // if(verifyImages.length > 0) {
    //   if(verifyImages.length > 1) {
    //     // let tempImages = verifyImages.map(v => v[0]);
    //     // await form.append('images', tempImages);
    //     await form.append('images', verifyImages);
    //   }
    //   else {
    //     await form.append('images', [verifyImages[0]]);
    //   }
    // }
    // else {
    //   await form.append('images', []);
    // }
    // await form.append('images', verifyImages[0]);
    // verifyImages.map(async (vImg, vIdx)=>{
    //   console.log(vImg);
    //   await form.append('images'+(vIdx+1), verifyImages);
    // });

    // console.log('form', form, form.getAll('checklist_ids'));

    // let pData = {
    //   checklist_ids: verifyThese.map(v => v.id),
    //   comment: verifyComment,
    //   images: [],
    // }
    // return; 

    setLoading(true);
    postMultipart(url.POST_VERIFICATION, form)
      .then((response) => {
        console.log('ver RESP', response);
        if (response.status == 200) {
          setVerifyComment('');
          setVerifyImages([]);
          setVerifyThese([]);
          fetchData();
        }
        else if (response.status == 400) {
          cogoToast.error('Could not perform verification');
        }
        else {
          console.log('err::', response);
          cogoToast.error('Could not perform verification');
        }
        setLoading(false);
      }, (error) => {
        console.log(error);
        setLoading(false);
      });

  };


  const resetForm = () => {
    setServicetypes([]);
    setSelectedGroups([]);
    setReportDate(moment().subtract(1, 'day').format('YYYY-MM-DD'));
  }





  // const displayedGroups = selectedServicetypes.length > 0 ? groups : [];
  // const displayedGroups = servicetype ? groups.filter(g => g.servicetype_id == servicetype.value) : groups;
  // const displayedActivities = asset ? asset.activities : [];

  // console.log(displayedAssets, assettype);




  React.useEffect(() => {
    if (props.filterBlock) {
      setSelectedGroups([]);
      setSelectedServicetypes([]);
      init();
    }
  }, [props.filterBlock]);

  // console.log('data', selectedServicetypes, selectedGroups, displayedGroups);

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Daily Logbook | Digital Logbook</title>
        </MetaTags>
        <Container fluid>

          {showLightbox &&
            <Lightbox
              mainSrc={images[photoIndex]}
              nextSrc={images[(photoIndex + 1) % images.length]}
              prevSrc={images[(photoIndex + images.length - 1) % images.length]}
              onCloseRequest={() => setShowLightbox(false)}
              enableZoom={false}
              onMovePrevRequest={() => {
                setPhotoIndex((photoIndex + images.length - 1) % images.length);
              }}
              onMoveNextRequest={() => {
                setPhotoIndex((photoIndex + 1) % images.length);
              }}
            />
          }
          <h3 className="mt-2 mb-4">Daily Logbook</h3>

          <div className="border border-light p-4 rounded" style={{ backgroundColor: 'rgb(235, 235, 241)' }}>

            <Row noGutters>
              <Col xs={{ size: '4' }} className="">
                <label
                  htmlFor="service-type-input"
                  className=""
                >
                  Date
                    </label>
                <div className="col-md-10">
                  <input className="form-control" type="date" value={reportDate} onChange={e => { setReportDate(e.target.value) }} />
                  {/* <Select
                            classNamePrefix="select2-selection"
                            placeholder="All"
                            title="Asset type"
                            options={assettypes}
                            value={assettype}
                            isClearable
                            onChange={e => { 
                              setActivity(null);
                              setAsset(null);
                              setAssettype(e); 
                            }}
                            /> */}
                </div>
              </Col>
              <Col xs={{ size: '4' }} className="">
                <label
                  htmlFor="service-type-input"
                  className=""
                >
                  Service Types
                    </label>
                <div className="col-md-10">
                  <Input
                    type="select"
                    options={servicetypes}
                    // value={selectedServicetypes}
                    multiple
                    onChange={event => {
                      // setActivity(null);
                      // console.log('e', e.target.value, event.target.selectedOptions);
                      // let temp = [];
                      // event.target.selectedOptions.map((opt, optIdx)=>{
                      //   temp.push(opt);
                      // });
                      let rawGroups = [];
                      let value = Array.from(
                        event.target.selectedOptions,
                        (option) => {
                          rawGroups = rawGroups.concat(groups.filter(g => g.servicetype_id == option.value));
                          return { value: option.value, label: option.label };
                        }
                      );
                      console.log('rawGroups', rawGroups);
                      setSelectedServicetypes(value);
                      setSelectedGroups(rawGroups);
                      setDisplayedGroups(rawGroups);
                      // setSelectedServicetypes(e.target.value); 
                    }}
                  >
                    {servicetypes.map((sType, sTypeIdx) => (
                      <option key={sTypeIdx} value={sType.value}>{sType.label}</option>
                    ))}
                  </Input>
                </div>
              </Col>
              <Col xs={{ size: '4' }} className="">
                <label
                  htmlFor="service-type-input"
                  className=""
                >
                  Groups
                    </label>
                <div className="col-md-10">
                  <Select
                    classNamePrefix="select2-selection"
                    placeholder="Select one..."
                    title="Group"
                    isMulti
                    options={displayedGroups}
                    value={selectedGroups}
                    closeMenuOnSelect={false}
                    onChange={e => {
                      setSelectedGroups(e);
                    }}
                  />
                </div>
              </Col>
            </Row>

            <Row noGutters className="mt-4" style={{ paddingTop: 8 }}>
              {/* <Col xs={{ size: '1' }} className="">
                          </Col> */}
              {/* <Col xs={{ size: '4' }} className="">
                            <div className="">
                              <p className="fs-5 fw-bold">Alerts</p>
                              <div className="form-check form-switch form-switch-md">
                                  <input type="checkbox" id="checkbox_1" className="form-check-input checkbox"
                                  //   checked={props.isPreloader}
                                  //   onChange={() => {  }}
                                  />
                                  <label className="form-check-label" htmlFor="checkbox_1">
                                  Normal
                                  </label>
                              </div>
                              <div className="form-check form-switch form-switch-md">
                                  <input type="checkbox" id="checkbox_1" className="form-check-input checkbox"
                                  //   checked={props.isPreloader}
                                  //   onChange={() => {  }}
                                  />
                                  <label className="form-check-label" htmlFor="checkbox_1">
                                  Alert
                                  </label>
                              </div>
                              <div className="form-check form-switch form-switch-md">
                                  <input type="checkbox" id="checkbox_1" className="form-check-input checkbox"
                                  //   checked={props.isPreloader}
                                  //   onChange={() => {  }}
                                  />
                                  <label className="form-check-label" htmlFor="checkbox_1">
                                  Ticket
                                  </label>
                              </div>
                            </div>
                        </Col> */}
              <Col xs={{ size: '6' }} className="d-flex justify-content-center">
                <div className="">
                  <p className="fs-5 fw-bold">Task status</p>
                  <div className="form-check form-switch form-switch-md">
                    <input type="checkbox" id="checkbox_completed" className="form-check-input checkbox"
                      checked={completed}
                      onChange={() => { setCompleted(!completed); }}
                    />
                    <label className="form-check-label" htmlFor="checkbox_completed">
                      Completed
                                  </label>
                  </div>
                  <div className="form-check form-switch form-switch-md">
                    <input type="checkbox" id="checkbox_canceled" className="form-check-input checkbox"
                      checked={canceled}
                      onChange={() => { setCanceled(!canceled); }}
                    />
                    <label className="form-check-label" htmlFor="checkbox_canceled">
                      Canceled
                                  </label>
                  </div>
                  <div className="form-check form-switch form-switch-md">
                    <input type="checkbox" id="checkbox_delayed" className="form-check-input checkbox"
                      checked={delayed}
                      onChange={() => { setDelayed(!delayed); }}
                    />
                    <label className="form-check-label" htmlFor="checkbox_delayed">
                      Delayed
                                  </label>
                  </div>
                  <div className="form-check form-switch form-switch-md">
                    <input type="checkbox" id="checkbox_missed" className="form-check-input checkbox"
                      checked={missed}
                      onChange={() => { setMissed(!missed); }}
                    />
                    <label className="form-check-label" htmlFor="checkbox_missed">
                      Missed
                                  </label>
                  </div>
                </div>
              </Col>
              <Col xs={{ size: '6' }} className="">
                <div className="">
                  <p className="fs-5 fw-bold">Verification</p>
                  <div className="form-check form-switch form-switch-md">
                    <input type="checkbox" id="checkbox_verified" className="form-check-input checkbox"
                      checked={verified}
                      onChange={() => { setVerified(!verified); }}
                    />
                    <label className="form-check-label" htmlFor="checkbox_verified">
                      Verified
                                </label>
                  </div>
                  <div className="form-check form-switch form-switch-md">
                    <input type="checkbox" id="checkbox_nonverified" className="form-check-input checkbox"
                      checked={nonVerified}
                      onChange={() => { setNonVerified(!nonVerified); }}
                    />
                    <label className="form-check-label" htmlFor="checkbox_nonverified">
                      Non-verified
                                </label>
                  </div>
                </div>
              </Col>
            </Row>

            <div className="text-center mt-5 mb-2">
              <Button
                color="primary"
                className="btn btn-secondary me-2"
                onClick={() => {
                  resetForm();
                }}
              >
                Reset
                        </Button>
              <Button
                color="primary"
                className="btn btn-primary ms-2"
                onClick={() => {
                  fetchData();
                }}
              >
                Submit
                        </Button>
            </div>
          </div>

















          <div className="mt-4">
            {/* { (reportDate == undefined || endDate == undefined) &&
          <div>
            Please select start and end dates
          </div>
          }
          { (reportDate !== undefined && endDate !== undefined) && */}
            <div>
              {loading ?
                <div>Loading..</div>
                :
                <div>
                  {data.length < 1 ?
                    <div className="text-center p-5 text-muted fst-italic">No data</div>
                    :
                    <div className="">
                      <div className="py-2 px-3" style={{ backgroundColor: 'rgba(73, 84, 103, 0.06)' }}>
                        <div className="d-flex flex-row justify-content-between align-items-center">
                          <div className="flex-1">
                            <div className="form-check form-switch form-switch-md">
                              <input type="checkbox" id="checkbox_uom" className="form-check-input checkbox"
                                checked={scantype}
                                onChange={() => { setScantype(!scantype); }}
                              />
                              <label className="form-check-label" htmlFor="checkbox_uom">
                                Scan type
                              </label>
                            </div>
                          </div>
                          <div className="flex-1">
                            <div className="form-check form-switch form-switch-md">
                              <input type="checkbox" id="checkbox_fieldrange" className="form-check-input checkbox"
                                checked={userComments}
                                onChange={() => { setUserComments(!userComments); }}
                              />
                              <label className="form-check-label" htmlFor="checkbox_fieldrange">
                                User comments
                              </label>
                            </div>
                          </div>
                          <div className="flex-1">
                            <div className="form-check form-switch form-switch-md">
                              <input type="checkbox" id="checkbox_saferange" className="form-check-input checkbox"
                                checked={mapLocation}
                                onChange={() => { setMapLocation(!mapLocation); }}
                              />
                              <label className="form-check-label" htmlFor="checkbox_saferange">
                                Map location
                              </label>
                            </div>
                          </div>
                          <div className="flex-1">
                            <div className="form-check form-switch form-switch-md">
                              <input type="checkbox" id="checkbox_attachments" className="form-check-input checkbox"
                                checked={attachments}
                                onChange={() => { setAttachments(!attachments); }}
                              />
                              <label className="form-check-label" htmlFor="checkbox_attachments">
                                Attachments
                              </label>
                            </div>
                          </div>
                          <div className="flex-1">
                            <div className="form-check form-switch form-switch-md">
                              <input type="checkbox" id="checkbox_attachments" className="form-check-input checkbox"
                                checked={verifications}
                                onChange={() => { setVerifications(!verifications); }}
                              />
                              <label className="form-check-label" htmlFor="checkbox_attachments">
                                Verification
                              </label>
                            </div>
                          </div>
                          <div className="flex-1 text-end">
                            <div>
                              <button className="btn btn-secondary">Export</button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <Card>
                        <CardBody>
                          <div className="table-rep-plugin">
                            <div className="table-responsive mb-0"
                              data-pattern="priority-columns">
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th>Asset name</th>
                                    <th>Activity name</th>
                                    <th>Scheduled date</th>
                                    <th>Done at</th>
                                    {/* {fields.map((field, fieldIdx)=>(
                                      <th key={fieldIdx}>{field.label}</th>
                                    ))} */}
                                    <th>Task done by</th>
                                    {scantype &&
                                      <th>
                                        Scan type
                                    </th>
                                    }
                                    {userComments &&
                                      <th>
                                        User comments
                                    </th>
                                    }
                                    {mapLocation &&
                                      <th>
                                        Map location
                                    </th>
                                    }
                                    {verifications &&
                                      <th>
                                        Verified at
                                    </th>
                                    }
                                    {verifications &&
                                      <th>
                                        Verified by
                                    </th>
                                    }
                                    {verifications &&
                                      <th>
                                        Verification comment
                                    </th>
                                    }
                                    <th>Verification</th>
                                    {attachments &&
                                      <th>
                                        Attachments
                                    </th>
                                    }
                                  </tr>
                                </thead>
                                <tbody>
                                  {data.map((tdRow, tdRowIdx) => (
                                    <tr key={tdRowIdx}>
                                      <td>{tdRow.asset ? tdRow.asset.name : '-'}</td>
                                      <td>{tdRow.activity ? tdRow.activity.name : '-'}</td>
                                      <td>{moment(tdRow.task_date).format('DD MMM YYYY')}</td>
                                      <td>{tdRow.ended_at ? moment(tdRow.ended_at).format('DD MMM YYYY hh:mm a') : '-'}</td>
                                      <td>{tdRow.user ? tdRow.user.name : '-'}</td>
                                      {scantype &&
                                        <td>{tdRow.scan_type}</td>
                                      }
                                      {userComments &&
                                        <td>-</td>
                                      }
                                      {mapLocation &&
                                        <td>-</td>
                                      }

                                      { verifications &&
                                        <td>
                                          {tdRow.checklist.verifications.length < 1 ? '-' :
                                            moment(tdRow.checklist.verifications[tdRow.checklist.verifications.length - 1].created_at).format('DD MMM YYYY hh:mm a')}
                                        </td>
                                      }
                                      { verifications &&
                                        <td>
                                          {tdRow.checklist.verifications.length < 1 ? '-' :
                                            tdRow.checklist.verifications[tdRow.checklist.verifications.length - 1].user.name}
                                        </td>
                                      }
                                      { verifications &&
                                        <td>
                                          {tdRow.checklist.verifications.length < 1 ? '-' :
                                            (tdRow.checklist.verifications[tdRow.checklist.verifications.length - 1].comment.substring(0, 20) + (tdRow.checklist.verifications[tdRow.checklist.verifications.length - 1].comment.length > 20 ? '..' : ''))}
                                        </td>
                                      }




                                      <td>
                                        {((tdRow.task_status == 'completed') && tdRow.checklist) ?
                                          <div>
                                            {((tdRow.checklist.verifications) && (tdRow.checklist.verifications.length > 0)) ?
                                              <Button color="success" size="sm" onClick={() => {
                                                setVerification(tdRow)
                                              }}>
                                                View
                                          </Button>
                                              :
                                              <Button color="info" size="sm" onClick={() => {
                                                setVerifyThese([{ id: tdRow.checklist.id, name: tdRow.activity.name }])
                                              }}>Verify</Button>
                                            }
                                          </div>
                                          :
                                          <div>&nbsp;</div>
                                        }
                                      </td>
                                      { attachments &&
                                        <td width={80}>
                                          {tdRow.checklistimages?.length > 0 &&
                                            <div className="link-attachments d-flex flex-row"
                                              onClick={() => {
                                                let imgs = [];
                                                tdRow.checklistimages.map((cImg, cImgIdx) => {
                                                  imgs.push("https://apilogbook.six30labs.com/storage/checklistimages/" + cImg.filename);
                                                });
                                                setImages(imgs);
                                                setPhotoIndex(0);
                                                setShowLightbox(true);
                                              }}
                                            >
                                              <i className="bx bx-image" style={{ color: '#667CE8', fontSize: 18, marginRight: 5, }}></i>
                                              {tdRow.checklistimages.length}
                                            </div>}
                                        </td>}
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </div>

                  }
                </div>
              }
            </div>
            {/* } */}
          </div>

          {verifyThese.length > 0 &&
            <Modal isOpen={verifyThese.length > 0} centered>
              <ModalHeader toggle={() => { setVerifyThese([]); }}>Verify Checklists</ModalHeader>
              <ModalBody>
                <p className="fw-bold mb-2">Add Verification for:</p>
                <div className="mb-5">
                  <ul>
                    {verifyThese.map((vItem, vIdx) => (
                      <li key={vIdx} className="">
                        {vItem.name}
                      </li>
                    ))}
                  </ul>
                </div>

                <form encType="multipart/form-data" id="verForm">
                  <FormGroup>
                    <Label>Verification comment</Label>
                    <Input
                      type="textarea"
                      id="textarea"
                      value={verifyComment}
                      onChange={e => {
                        setVerifyComment(e.target.value)
                      }}
                      maxLength="225"
                      rows="3"
                      placeholder="Start typing..."
                    />
                  </FormGroup>


                  <FormGroup className="mt-4">
                    <Label for="exampleFile" className="col-form-label">
                      Images (Optional)
                  </Label>
                    <div className="mt-1 mb-1">
                      <Input
                        id="exampleFile"
                        // name="file"
                        type="file"
                        multiple={true}
                        // value={verifyImages}
                        onChange={e => {
                          console.log('file e', e.target.files, e.target.value);
                          setVerifyImages(e.target.files);
                        }}
                      />
                    </div>
                    <FormText>
                      Hold Ctrl to select multiple image files
                  </FormText>
                  </FormGroup>

                </form>

              </ModalBody>
              <ModalFooter>
                <Button color="secondary" onClick={() => {
                  setVerifyComment('');
                  setVerifyThese([]);
                }}>Cancel</Button>{' '}
                <Button color="primary" onClick={() => {
                  doVerify();
                }}>Submit</Button>
              </ModalFooter>
            </Modal>
          }


          {verification &&
            <Modal isOpen={verification !== null} centered>
              <ModalHeader toggle={() => { setVerification(null); }}>Verification Log</ModalHeader>
              <ModalBody>
                <p className="fw-bold mb-2">Verification for:</p>
                <div className="mb-5">
                  {verification.activity.name}
                </div>

                {verification.checklist.verifications.length > 0 &&
                  <div>
                    <h5 className="h5 mt-5 mb-3">Verification History</h5>
                    <div>
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th>Comment</th>
                            <th>Verified by</th>
                            <th>Verified at</th>
                            <th>Images</th>
                          </tr>
                        </thead>
                        <tbody>
                          {verification.checklist.verifications.map((vItem, vIdx) => (
                            <tr key={vIdx}>
                              <td>{vItem.comment}</td>
                              <td>Admin</td>
                              <td>{moment(vItem.created_at).format('DD MMM YYYY hh:mm a')}</td>
                              <td>{
                                vItem.verificationimages.length > 0 ?
                                  <div className="link-attachments d-flex flex-row"
                                    onClick={() => {
                                      let imgs = [];
                                      vItem.verificationimages.map((cImg, cImgIdx) => {
                                        imgs.push("https://apilogbook.six30labs.com/storage/verification_daily/" + cImg.filename);
                                      });
                                      setImages(imgs);
                                      setPhotoIndex(0);
                                      setShowLightbox(true);
                                    }}
                                  >
                                    <i className="bx bx-image" style={{ color: '#667CE8', fontSize: 18, marginRight: 5, }}></i>
                                    {vItem.verificationimages.length}</div> :
                                  <span className="text-muted">-</span>
                              }</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                }


              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={() => {
                  setVerifyThese([{ id: verification.checklist.id, name: verification.activity.name }]);
                  setVerification(null);
                }}>Add Verification</Button>
                <Button color="secondary" onClick={() => {
                  setVerification(null);
                }}>Close</Button>{' '}
              </ModalFooter>
            </Modal>
          }


        </Container>
      </div>


    </React.Fragment>
  )
}

const mapStatetoProps = (state) => {
  const {
    filterBlock,
    filterProperty
  } = state.filters
  return { filterBlock, filterProperty }
}

export default connect(mapStatetoProps)(DailyLogbook)